export default {
  getAllSemesterRequestToUnblockLec:
    "/lectureUnblockReq/getAllSemesterRequestToUnblockLec",
  getAllReqForSubjectForFacultyForDivision:
    "/lectureUnblockReq/getAllReqForSubjectForFacultyForDivision",
  createSingleRequestForLectureUnlock:
    "/lectureUnblockReq/createSingleRequestForLectureUnlock",
  updateSingleRequest: "/lectureUnblockReq/updateSingleRequest"
};
